import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { t } from '~/helpers';
import MyForm from './form';
const formRef = createRef();

class AprovarFaturametoGFE extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      params: {},
      salvando: false,
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
      salvando: false
    }));
  }

  // Close modal
  async handleCloseModal() {
    await this.setState({ open: false });
  }

  async hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
      salvando: false
    }));
  }

  async handlesub() {
    await this.setState((prevState) => ({
      ...prevState,
      salvando: true
    }));
    await formRef.current.submitForm()
  }

  render() {
    const { open, params, salvando } = this.state;
    return (
      <Dialog
        open={open}
        maxWidth="xl"
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 450}
        PaperProps={{
          style: {
            height: '75vh',  // Define a altura do dialog
            width: '60vw',
            maxHeight: 'none',  // Remove o limite de altura
            maxWidth: 'none',
          },
        }}
      >
        <DialogTitle>
          {'Aprovar faturamento'}
        </DialogTitle>
        <DialogContent>
          <MyForm
            data={params}
            reference={formRef}
            close={() => {
              this.handleCloseModal();
              this.props.update();
            }}
            cancelarAcao={() => this.hancleCancelarAcao()}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={salvando}
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={(event) => formRef.current.submitForm(event)}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>

          <Button
            disabled={salvando}
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(AprovarFaturametoGFE);
